<template>
    <v-dialog v-model="visible" persistent max-width="620px">
        <v-card>
            <v-card-title class="justify-center">
                <v-switch
                    dense
                    inset
                    true-value="ativo"
                    false-value="inativo"
                    hide-details
                    class="pb-2"
                    v-model="form.status"
                    :label="form.status == 'ativo' ? 'Disponível' : 'Indisponível'"
                />
                <v-spacer/>
                <span class="text-h5">{{ form.id ? 'Edição' : 'Cadastro' }} de Grupo</span>
                <v-spacer/>
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-text-field
                    ref="descricao"
                    label="Descrição"
                    v-model="form.descricao"
                    outlined
                    dense
                    hide-details
                    class="mt-2"
                />
                <v-select
                    :items="setores"
                    v-model="form.kds_setor_id"
                    item-value="id"
                    item-text="nome"
                    outlined
                    dense
                    label="Setor"
                    hide-details
                    class="mt-4"
                    clearable
                />
                <div class="d-flex align-center mt-4">
                    <v-switch
                        dense
                        inset
                        hide-details
                        v-model="form.mostra_cardapio"
                        label="Exibir no Cardápio Digital"
                    />
                    <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Controla a exibição deste grupo no cardápio digital acessado pelo link e QR Code.</span>
                    </v-tooltip>
                </div>
                <div class="d-flex align-center mt-2">
                    <v-switch
                        dense
                        inset
                        hide-details
                        v-model="form.mostra_tablet"
                        label="Exibir no Tablet"
                    />
                    <v-tooltip bottom max-width="280">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="grey" class="ml-2" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span>Controla a exibição deste grupo no tablet de mesa, disponível no módulo Tablet de Mesa para autoatendimento.</span>
                    </v-tooltip>
                </div>
                <div class="mt-5">
                    <div class="d-flex align-center mb-2">
                        <v-icon small color="grey darken-1" class="mr-1">mdi-shape</v-icon>
                        <span class="body-2 font-weight-medium grey--text text--darken-2">
                            Ícone do Grupo
                        </span>

                        <div v-if="form.icone" class="d-flex align-center ml-3">
                            <img
                                :src="getIconUrl(form.icone)"
                                width="22"
                                height="22"
                                class="mr-1"
                                style="opacity: 0.8;"
                            />
                            <span class="caption grey--text">{{ getIconLabel(form.icone) }}</span>
                            <v-btn
                                icon
                                x-small
                                color="grey"
                                class="ml-1"
                                @click="form.icone = null"
                                title="Remover ícone"
                            >
                                <v-icon x-small>mdi-close-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>

                    <v-text-field
                        v-model="iconSearch"
                        placeholder="Pesquisar ícone... (ex: pizza, cerveja, combo)"
                        prepend-inner-icon="mdi-magnify"
                        outlined
                        dense
                        clearable
                        hide-details
                        class="mb-2"
                    />

                    <div class="icon-grid-wrapper">
                        <div v-if="filteredIcons.length" class="icon-grid">
                            <div
                                v-for="icon in filteredIcons"
                                :key="icon.name"
                                class="icon-item"
                                :class="{ 'icon-item--selected': form.icone === icon.name }"
                                @click="form.icone = icon.name"
                                :title="icon.label"
                            >
                                <img
                                    :src="getIconUrl(icon.name)"
                                    width="30"
                                    height="30"
                                    class="icon-item__img"
                                />
                                <div class="icon-item__label">{{ icon.label }}</div>
                            </div>
                        </div>
                        <div v-else class="d-flex align-center justify-center pa-4 grey--text caption">
                            <v-icon small class="mr-1">mdi-emoticon-sad-outline</v-icon>
                            Nenhum ícone encontrado
                        </div>
                    </div>
                </div>
                <h3 class="mt-8">Disponibilidade</h3>

                <v-radio-group
                    v-model="form.disponibilidade.sempre_disponivel"
                    row
                    hide-details
                    style="margin-top: 5px;"
                >
                    <v-radio
                        label="Sempre disponível"
                        :value="true"
                    />
                    <v-radio
                        label="Dias e horários específicos"
                        :value="false"
                    />
                </v-radio-group>

                <div v-if="!form.disponibilidade.sempre_disponivel" class="mt-4 mb-4">
                    <v-row align="center" v-for="d in form.disponibilidade.programacao" :key="d.diaSemana">
                        <v-switch
                            dense
                            inset
                            hide-details
                            class="mr-2"
                            style="width: 95px;"
                            v-model="d.aberto"
                            :label="d.diaSemana.substr(0, 3)"
                        />
                        <v-text-field
                            v-model="d.horario"
                            hide-details
                            style="max-width: 105px; border: 1px solid #ddd; border-radius: 5px; padding-left: 5px;"
                            v-mask="['##:## - ##:##']"
                            placeholder="00:00 - 00:00"
                            :disabled="!d.aberto"
                        />
                        <v-btn
                            icon
                            small
                            color="primary"
                            v-if="!d.segundoHorarioAtivo"
                            @click="toogleSegundoHorario(d.diaSemana)"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-text-field
                            v-else
                            v-model="d.segundoHorario"
                            hide-details
                            style="max-width: 130px; border: 1px solid #ddd; border-radius: 5px; padding-left: 5px;"
                            v-mask="['##:## - ##:##']"
                            placeholder="00:00 - 00:00"
                            :disabled="!d.aberto"
                        >
                            <template v-slot:append-outer>
                                <v-btn icon x-small @click="toogleSegundoHorario(d.diaSemana)">
                                    <v-icon color="red">mdi-delete</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer />
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { CATEGORIAS_ICONS, getIconUrl } from '@/utils/categoriaIcons';
import { getTimeErrors } from '@/utils/validate';

const defaultDisponibilidade = () => ({
    sempre_disponivel: true,
    programacao: [
        {isoWeekday: 1, diaSemana: 'SEGUNDA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 2, diaSemana: 'TERCA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 3, diaSemana: 'QUARTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 4, diaSemana: 'QUINTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 5, diaSemana: 'SEXTA', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 6, diaSemana: 'SÁBADO', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
        {isoWeekday: 7, diaSemana: 'DOMINGO', horario: '', segundoHorario: '', segundoHorarioAtivo: false, aberto: false},
    ],
});

const defaultForm = () => ({
    descricao: '',
    ativo: true,
    status: 'ativo',
    kds_setor_id: null,
    mostra_tablet: true,
    mostra_cardapio: true,
    icone: null,
    disponibilidade: defaultDisponibilidade(),
});

export default {
    name: 'Grupo',

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        formData: {
            type: Object,
            default: Object,
        },
    },

    data: () => ({
        loading: false,
        form: defaultForm(),
        setores: [],
        iconSearch: '',
    }),

    computed: {
        filteredIcons() {
            const q = (this.iconSearch || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            if (!q) return CATEGORIAS_ICONS;

            return CATEGORIAS_ICONS.filter(icon => {
                const label = icon.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                const kws   = icon.keywords.join(' ').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                return label.includes(q) || kws.includes(q);
            });
        },
    },

    mounted() {
        this.fillSetores();
        this.form = this.buildForm(this.formData);
    },

    watch: {
        formData(value) {
            this.form = this.buildForm(value);
            this.iconSearch = '';
            setTimeout(() => this.$refs.descricao.focus(), 100);
        },
    },

    methods: {
        buildForm(value) {
            const v = value ? JSON.parse(JSON.stringify(value)) : {};
            const form = { ...defaultForm(), ...v };
            if (!form.disponibilidade || !form.disponibilidade.programacao) {
                form.disponibilidade = defaultDisponibilidade();
            }
            return form;
        },

        toogleSegundoHorario(diaSemana) {
            const programacao = this.form.disponibilidade.programacao.find(f => f.diaSemana == diaSemana);
            programacao.segundoHorarioAtivo = !programacao.segundoHorarioAtivo;
            this.$forceUpdate();
        },

        getIconUrl(name) {
            return getIconUrl(name);
        },

        getIconLabel(name) {
            const icon = CATEGORIAS_ICONS.find(i => i.name === name);
            return icon ? icon.label : name;
        },

        fillSetores() {
            this.setores = [];
            this.$http.get('setores').then(resp => {
                this.setores = resp.data.data;
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            });
        },

        salvar() {
            const id = this.form.id;

            const timeError = getTimeErrors(this.form.disponibilidade.programacao);

            if (timeError) {
                this.notify(timeError, 'warning');
                return;
            }

            if (id) {
                this.loading = true;
                this.$http.put(`grupos/${id}`, this.form).then(() => {
                    this.$emit('onCadastro');
                    this.notify('Atualizado com sucesso!');
                }).catch(() => {
                    this.notify('Verifique sua conexão com a internet', 'warning');
                }).finally(() => (this.loading = false));
                return;
            }

            this.loading = true;
            this.$http.post('grupos', this.form).then(resp => {
                this.$emit('onCadastro', resp.data.data);
                this.notify('Salvo com sucesso!');
            }).catch(() => {
                this.notify('Verifique sua conexão com a internet', 'warning');
            }).finally(() => (this.loading = false));
        },
    },
}
</script>

<style scoped>
.v-card {
    padding: 0 15px 0 15px;
}

.icon-grid-wrapper {
    max-height: 240px;
    overflow-y: auto;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 6px;
    background: #fafafa;
}

.icon-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 4px;
}

.icon-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 4px 6px;
    border-radius: 8px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: background 0.15s, border-color 0.15s;
    user-select: none;
}

.icon-item:hover {
    background: rgba(0, 0, 0, 0.06);
}

.icon-item--selected {
    border-color: var(--v-primary-base);
    background: rgba(0, 0, 0, 0.05);
}

.icon-item__img {
    opacity: 0.75;
    transition: opacity 0.15s;
}

.icon-item:hover .icon-item__img,
.icon-item--selected .icon-item__img {
    opacity: 1;
}

.icon-item__label {
    font-size: 9.5px;
    text-align: center;
    margin-top: 4px;
    line-height: 1.2;
    color: #666;
    max-width: 72px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Scrollbar sutil */
.icon-grid-wrapper::-webkit-scrollbar {
    width: 5px;
}
.icon-grid-wrapper::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.15);
    border-radius: 4px;
}
</style>
